import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { useToasts } from 'react-toast-notifications';
import ClipLoader from "react-spinners/ClipLoader";

import { makeStyles } from "@material-ui/core/styles";

import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
import Button from "components/CustomButtons/Button.js";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardBody from "components/Card/CardBody.js";
import CardFooter from "components/Card/CardFooter.js";

import api from '../../services/api';

const styles = {
  cardTitleWhite: {
    fontSize: '31px',
    color: "#1989FF",
    textAlign: 'center'
  },

  gridContainer: {
    height: '100vh',
    width: '100%',
    marginTop: '-70px',
  },

  textInfo: {
    color: '#828282',
    height: '0px',
    fontSize: '14px',
    textAlign: 'center',
    fontWeight: '700',
    marginTop: 10
  },
};

const useStyles = makeStyles(styles);

export default function Lgpd() {
  const classes = useStyles();
  const history = useHistory();
  const { addToast } = useToasts();
  const [loading, setLoading] = useState(false);  
  const [aceitouLgpd, setAceitouLgpd] = useState(false);  

  useEffect(() => {
    (async () => {
      try {
        let usuario = await api.getUsuario();

        let resp = await api.aceitouLgpd(usuario.data.id);
          
        if (resp.success) {
          setAceitouLgpd(true);          
        };
      } catch (err) {
        setLoading(false);
        if (err.statusCode === 401) {
          localStorage.clear();
          history.push("/");
          addToast(err.message, { appearance: 'error' });
        } else {
          addToast(err.message, { appearance: 'error' });
        }
      }
    })();
  }, []);

  const confirmarTermo = async () => {    
    try {
      let usuario = await api.getUsuario();

      if (usuario.success) {
        setLoading(true);
        
        let resp = await api.aceiteLgpd(usuario.data.id);
        
        if (resp.success) {
          setLoading(false);
          history.push("/registrar");
        };
      }
    } catch (err) {
      setLoading(false);
      addToast(err.message, { appearance: 'error' });
    }  
  };


  return (
    <div className={classes.gridContainer}>
      <GridContainer style={{ position: 'fixed', justifyContent: 'center', alignItems: 'center', height: '100vh', textAlign: 'center', zIndex: 1 }}>
        
          <Card style={{
            backgroundColor: '#f8f9fd',
            borderRadius: 25,
            borderBottomLeftRadius: 25,
            borderBottomRightRadius: 25,
            borderTopLeftRadius: 25,
            borderTopRightRadius: 25,
            borderColor: '#C8C8C8',
            height: '600px',
            width: '800px',
            boxShadow: '0 1px 4px 0 rgb(0 0 0 / 40%)'
          }}>
            <CardHeader style={{ height: '30px', marginTop: 20 }}>
              <h4 className={classes.cardTitleWhite} style={{
                fontWeight: 400,
                color: '#1989ff',
                fontSize: 22,
                lineHeight: '28px'
              }}>LGPD</h4>
            </CardHeader>

            <CardHeader style={{ padding: '8px 5px 0px 5px', justifyContent: 'center', borderBlockEnd: '1px solid #ddd', textAlign: 'center' }}>
                <label className={classes.textInfo}>
                  TERMO DE CONSENTIMENTO PARA ARMAZENAMENTO E <br></br>TRATAMENTO DE DADOS PESSOAIS EM CONFORMIDADE COM A LGPD
                </label>
              </CardHeader>
              
            <div style={{ marginTop: 0, height: 800, width: 800, overflowX: 'auto' }}>
              <CardBody style={{ padding: 0 }}>
                <GridItem xs={12} sm={12} md={12} >              
                  <p align="justify">
                    Este termo visa registrar a manifestação livre, informada e inequívoca pela qual o titular concorda com 
                    o tratamento de seus dados pessoais para finalidade específica, em conformidade com a <b>Lei nº 13.709 – Lei 
                    Geral de Proteção de Dados Pessoais (LGPD).<br></br><br></br></b>
              
                    Informamos que coletamos seus <b>dados pessoais</b> (CPF, Nome, Telefone, E-mail) para  
                    <b> Registro de Ponto. </b>
                    Os seus dados pessoais serão armazenados e preservados por período indeterminado. Os dados são registrados
                    no sistema e podem ser anonimizados, visando a segurança dos dados.<br></br><br></br>
              
                    Você poderá, a qualquer momento: <br></br><br></br>
              
                    - Ter acesso às informações sobre a forma e a duração de tratamento dos seus dados na nossa plataforma; <br></br>
                    - Solicitar a atualização ou correção dos seus dados; <br></br>
                    - Solicitar a eliminação dos seus dados pessoais tratados e revogação do consentimento, nos termos da Lei. <br></br>
                    <br></br>
              
                    As solicitações e questionamentos acerca do tratamento e eliminação de seus dados deverão ser realizadas 
                    através do <b>suporte@viasoft.com.br</b><br></br><br></br>
              
                    Caso <b>ACEITE</b> que seus <b>dados pessoais</b> sejam coletados, por favor, concorde com este aviso.                
                  </p>                  
                </GridItem>              
              </CardBody>
            </div>

            <CardFooter style={{ justifyContent: 'center', alignItems: 'baseline', height: '100px', display: 'grid', padding: 0, marginTop: 30 }}>
              <Button style={{ borderRadius: '25px', width: 180 }} onClick={() => confirmarTermo()} color="primary" disabled={aceitouLgpd}>Aceitar</Button>
            </CardFooter>

            <div style={{ position: 'absolute', left: '50%', top: '50%', transform: 'translate(-50%, -50%)' }}>
              <ClipLoader
                size={80}
                color={"#364e6b"}
                loading={loading}
                css={{ border: '8px solid', borderBottomColor: 'transparent' }}
              />
            </div>
          </Card>        
      </GridContainer>
    </div>
  );
}
